export default __webpack_public_path__ + "static/media/SHORT-ON.743ff9db.png";